import { fetchEntities, filterEntities } from 'actions/entities';
import EntitiesMenu from 'components/entities/EntitiesMenu';
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getInvoiceConfigurations } from "../../selectors/invoice_configurations";
import InvoiceConfigurationForm from "./InvoiceConfigurationForm";

const mapStateToProps = (state, ownProps) => {
  return {
    entities: getInvoiceConfigurations(state),
    entityName: 'invoiceConfiguration',
    form: InvoiceConfigurationForm,
    item: (props) => <div>{`${props.invoiceConfiguration.name}`}</div>,
    loading: state.meta?.invoiceConfiguration?.loading,
    error: state.meta?.invoiceConfiguration?.error
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('invoiceConfigurations'))
    },
    filterEntities: (filter) => {
      dispatch(filterEntities('invoiceConfigurations', filter))
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EntitiesMenu));
